@if ({ exitsArray: exitsArray$ | async }; as data) {
    <ng-content select="[MenuMode]"/>
    <div class="tw-box-border tw-w-full tw-flex-1 tw-overflow-y-auto tw-p-1">
        <ng-content select="[Header]"/>
        <div class="tw-flex tw-flex-col tw-gap-1">
            @for (exit of data.exitsArray; track $index) {
                @if (!$index) {
                    <ng-container *ngTemplateOutlet="rows; context: { items: saleByKey[0] || [] }"/>
                } @else if (saleByKey[exit.nameValue || 0] || showAllExits) {
                    <div class="tw-mt-1 tw-flex tw-flex-col" [class.tw-mb-2]="!saleByKey[exit.nameValue || 0]">
                        <div class="tw-flex tw-items-end tw-justify-between tw-gap-2">
                            <button type="button"
                                    class="tw-cursor-pointer tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wider"
                                    [ngClass]="[
                                        saleByKey[exit.nameValue || 0] ? 'tw-rounded-t-lg' : 'tw-rounded-lg',
                                        exit.isSelected
                                            ? 'tw-border-0 tw-bg-[var(--sys-cashregister-cart-accent)] tw-text-[var(--sys-cashregister-cart-accent-contrast)]'
                                            : saleByKey[exit.nameValue || 0]
                                                ? 'tw-border-0 tw-bg-[var(--sys-cashregister-cart-group-bg)] tw-text-[var(--sys-text)]'
                                                : 'tw-border tw-border-solid tw-border-[color:var(--sys-cashregister-cart-group-bg)] tw-bg-[var(--sys-cashregister-cart-head-bg)] tw-text-[var(--sys-text)]'
                                    ]"
                                    (click)="exitChange.emit(exit)">
                                {{ exit.name | translate: { value: exit.nameValue } }}
                            </button>
                            @if (!disableExitStatus) {
                                <div class="tw-flex tw-items-center tw-gap-1">
                                    @switch (exit.status) {
                                        @case ('sending') { <mat-spinner class="tw-h-5 tw-w-5" [diameter]="20"/> }
                                        @case ('sent') { <mat-icon fontIcon="done_all"/> }
                                    }
                                    @if (saleByKey[exit.nameValue || 0]) {
                                        <mat-icon [class.tw-cursor-pointer]="exit.status != 'sending'"
                                                  [class.tw-pointer-events-none]="exit.status == 'sending'"
                                                  fontIcon="send"
                                                  (click)="exit.status != 'sending' && sendExit.emit(exit)"/>
                                    }
                                </div>
                            }
                        </div>
                        @if (saleByKey[exit.nameValue || 0]; as exitItems) {
                            <div class="tw-flex tw-flex-col tw-gap-1 tw-rounded-b-lg tw-rounded-tr-lg tw-p-1"
                                [ngClass]="[
                                    exit.isSelected
                                        ? 'tw-bg-[var(--sys-cashregister-cart-accent)]'
                                        : 'tw-bg-[var(--sys-cashregister-cart-group-bg)]'
                                ]">
                                <ng-container *ngTemplateOutlet="rows; context: { items: exitItems }"/>
                            </div>
                        }
                    </div>
                }
            }
        </div>

        @if (sale?.price_changes; as salePriceChanges) {
            <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-1 tw-px-1 tw-pb-2 tw-text-sm tw-font-medium tw-text-[var(--sys-cashregister-cart-accent)]">
                @for (priceChange of salePriceChanges; track $index) {
                    @if (priceChange.type !== 'disc_perc_nd') {
                        <div class="tw-flex tw-items-center tw-justify-between tw-gap-2"
                             tilbyGestures
                             (swipeLeft)="removePriceChangeFromSaleEmitter.emit(priceChange)">
                            <span class="tw-min-w-0 tw-flex-1">{{ $any(priceChange) | tilbyPriceChange: priceChangeDescriptions }}</span>
                            <span class="tw-shrink-0 tw-tabular-nums">{{ isHidePrices ? '***' : ((priceChange.amount || 0) | tilbyCurrency) }}</span>
                        </div>
                    }
                }
            </div>
        }
    </div>

    <ng-template #rows let-items="items">
        @for (saleItem of items; track saleItem.uuid) {
            <app-shop-cart-row-v2 #row
                [attr.id]="saleItem.uuid"
                [saleItem]="saleItem"
                [department]="findDepartmentById(saleItem.department_id)"
                [priceChangeDescriptions]="priceChangeDescriptions"
                [isHidePrices]="isHidePrices"
                [ingredientsRemovalAffectsPrice]="ingredientsRemovalAffectsPrice"
                [expanded]="expandAll !== expandedUuids().has(saleItem.uuid)"
                [selected]="saleItem.uuid == lastUuidSelected && isSelected"
                [grouped]="saleItem.uuid == groupItemUuid"
                [disabled]="isCoverItem(saleItem)"
                [flash]="saleItem.uuid == flashUuid()"
                [sent]="sentItemUuids.has(saleItem.uuid)"
                (rowClick)="clickEnabled && clickHandler(saleItem)"
                (rowMouseDown)="enableClick()"
                (toggleExpanded)="toggleExpanded(saleItem.uuid)"
                (swipeLeft)="swipeLeftHandler(saleItem)"
                (swipeRight)="swipeRightHandler(saleItem)"
                (longPress)="longPressHandler(saleItem)"
                (removePriceChange)="removePriceChangeFromSaleItem(saleItem, $event)"/>
        }
    </ng-template>
}
